import React from 'react';
import { Container } from '@/components/container';
import { Toolbar, ToolbarHeading } from '@/layouts/demo1/toolbar';
import { FormattedMessage } from 'react-intl';
import { MessageOverview, MessageTimeStats, MessageChannelStats, StatCard } from './components';
import { 
  faExternalLinkAlt, 
  faLightbulb, 
  faSearch, 
  faLink, 
  faFileAlt 
} from '@fortawesome/free-solid-svg-icons';

const DashBoard = () => {

    return (<>
        <Toolbar>
            <Container>
                <ToolbarHeading title={<FormattedMessage id={"USER.MENU.DASHBOARD_TITLE"} />} />
            </Container>
        </Toolbar>
        <Container >
            <div className='grid grid-cols-1 md:grid-cols-12 gap-6 pt-6'>
                <MessageOverview className='md:col-span-3' />
                <MessageTimeStats className='md:col-span-5' />
                <MessageChannelStats className='md:col-span-4' />
            </div>
            
            {/* Example usage of StatCard with both FontAwesome and KeenIcon */}
            <div className='grid grid-cols-1 md:grid-cols-5 pt-6 gap-5'>
                <StatCard 
                    number="20.000/15,246"
                    title="Bản ghi dữ liệu tham chiếu"
                    icon="data"
                    iconType="keenicon"
                    className="md:col-span-1"
                />
                <StatCard 
                    number="20.000/15,246"
                    title="Bản ghi Câu gợi ý"
                    icon="note-2"
                    iconType="keenicon"
                    className="md:col-span-1"
                />
                <StatCard 
                    number="20.000/15,246"
                    title="Bản ghi Mẫu truy vấn"
                    icon="feather"
                    iconType="keenicon"
                    className="md:col-span-1"
                />
                <StatCard 
                    number="20.000/15,246"
                    title="Bản ghi Liên kết tham chiếu"
                    icon="fasten"
                    iconType="keenicon"
                    className="md:col-span-1"
                />
                <StatCard 
                    number="20.000/15,246"
                    title="Bản ghi tài liệu tham chiếu"
                    icon="paper-clip"
                    iconType="keenicon"
                    className="md:col-span-1"
                />
            </div>
        </Container>
    </>
    );
};
export { DashBoard };
